import React from "react"

import { scale } from "utils"

const PlSeparator = (props) => {
  const { forPos, templateType } = props

  const styles =
    templateType === "thermal" ? stylesThermal : stylesOther

  return (
    <div style={forPos ? styles["lineContainerMargin"] : styles["lineContainer"]}>
      <div style={styles["line"]} />
    </div>
  )
}

const stylesThermal = {
  lineContainer: {
    padding: scale("8px")
  },
  lineContainerMargin: {
    padding: `scale("30px")`
  },
  line: {
    width: "100%",
    marginTop: scale("20px"),
    height: 0,
    borderBottom: `${scale("4px")} dashed black`
  }
}

const stylesOther = {
  lineContainer: {
    marginRight: "8px",
    padding: "4px"
  },
  line: {
    width: "100%",
    marginTop: "20px",
    height: "0px",
    borderBottom: "2px dashed black"
  }
}

export default PlSeparator